module.exports = __webpack_public_path__ + "img/icon_call.49eb7409.svg";